/*!

=========================================================
* Argon Dashboard React - v1.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2019 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
/*eslint-disable*/
import React from "react";
import { NavLink as NavLinkRRD, Link } from "react-router-dom";
// nodejs library to set properties for components
import { PropTypes } from "prop-types";
import "assets/vendor/nucleo/css/nucleo.css";
import "assets/vendor/@fortawesome/fontawesome-free/css/all.min.css";
import "assets/css/argon-dashboard-react.css";
import Moment from 'moment';
// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Collapse,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Media,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Progress,
  Table,
  Container,
  Row,
  Col
} from "reactstrap";

var ps;

class Sidebar extends React.Component {
  state = {
    versionvalue:6,
    collapseOpen: false,
    name:sessionStorage.getItem('Name'),
    ref:window.sessionStorage.getItem('Ref'),
    profileimageurl:sessionStorage.getItem('Profilepictureurl'),
    Level:sessionStorage.getItem('Level'),
    Billtoparty:window.sessionStorage.getItem('Billtoparty'),
    Directorforwarder:sessionStorage.getItem('Directorforwarder'),
    Email:window.sessionStorage.getItem('Email'),
    Contact:sessionStorage.getItem('Contact'),
    usernameinput:sessionStorage.getItem('Username'),
    linkurl:"https://crm.mewahtrans.com.my/api/mewahapicode.php?",
   // imageurllink:"http://crm.mewahtrans.com.my/img/profile_img/",
    //linkurl:"https://cors-anywhere.herokuapp.com/http://crm.mewahtrans.com.my/api/mewahapicode.php?",
    imageurllink:"https://crm.mewahtrans.com.my/api/img/profile_img/",
    have2account:sessionStorage.getItem('have2account'),
    usernameaccount1:sessionStorage.getItem('Username'),
    nameaccount1: sessionStorage.getItem('Name'),
    refacccount1: sessionStorage.getItem('Ref'),
    levelaccount1: sessionStorage.getItem('Level'),
    billtopartyaccount1: sessionStorage.getItem('Billtoparty'),
    directorforwarderaccount1: sessionStorage.getItem('Directorforwarder'),
    emailaccount1: sessionStorage.getItem('Email'),
    contactaccount1: sessionStorage.getItem('Contact'),
    profilepictureurlaccount1: sessionStorage.getItem('Profilepictureurl'),

    usernameaccount2:sessionStorage.getItem('Usernameaccount2'),
    nameaccount2: sessionStorage.getItem('Nameaccount2'),
    refacccount2: sessionStorage.getItem('Refaccount2'),
    levelaccount2: sessionStorage.getItem('Levelaccount2'),
    billtopartyaccount2: sessionStorage.getItem('Billtopartyaccount2'),
    directorforwarderaccount2: sessionStorage.getItem('Directorforwarderaccount2'),
    emailaccount2: sessionStorage.getItem('Emailaccount2'),
    contactaccount2: sessionStorage.getItem('Contactaccount2'),
    profilepictureurlaccount2: sessionStorage.getItem('Profilepictureurlaccount2'),
  };
  constructor(props) {
    super(props);
    this.activeRoute.bind(this);
    
  }
  componentDidMount() {
    
   
    this.interval = setInterval(() => {
    var datetemp = new Date().getDate()
    var monthtemp = new Date().getMonth() + 1
    var yeartemp = new Date().getFullYear()
    var hourtemp = new Date().getHours()
    var minutemp = new Date().getMinutes()
    var secondtemp = new Date().getSeconds()
    this.setState({ date: yeartemp + '-'+ ('0'+monthtemp).slice(-2) + '-' + ('0'+datetemp).slice(-2) +'T'+('0'+hourtemp).slice(-2)+ ':' + ('0'+minutemp).slice(-2) +':'+('0'+secondtemp).slice(-2) }), 1000
    }
    );
    
  }

  
  secondbilltopartyclick = () =>{  
    sessionStorage.setItem('Username', this.state.usernameaccount2);
    sessionStorage.setItem('Name', this.state.nameaccount2);
    sessionStorage.setItem('Ref', this.state.refacccount2);
    sessionStorage.setItem('Level', this.state.levelaccount2);
    sessionStorage.setItem('Billtoparty', this.state.billtopartyaccount2);
    sessionStorage.setItem('Directorforwarder', this.state.directorforwarderaccount2);
    sessionStorage.setItem('Email', this.state.emailaccount2);
    sessionStorage.setItem('Contact', this.state.contactaccount2);
    sessionStorage.setItem('Profilepictureurl', this.state.profilepictureurlaccount2);


    sessionStorage.setItem('Usernameaccount2', this.state.usernameaccount1);
    sessionStorage.setItem('Nameaccount2', this.state.nameaccount1);
    sessionStorage.setItem('Refaccount2', this.state.refacccount1);
    sessionStorage.setItem('Levelaccount2', this.state.levelaccount1);
    sessionStorage.setItem('Billtopartyaccount2', this.state.billtopartyaccount1);
    sessionStorage.setItem('Directorforwarderaccount2', this.state.directorforwarderaccount1);
    sessionStorage.setItem('Emailaccount2', this.state.emailaccount1);
    sessionStorage.setItem('Contactaccount2', this.state.contactaccount1);
    sessionStorage.setItem('Profilepictureurlaccount2', this.state.profilepictureurlaccount1);
    window.location.reload(false);

  }
  


  // verifies if routeName is the one active (in browser input)
  activeRoute(routeName) {
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  // toggles collapse between opened and closed (true/false)
  toggleCollapse = () => {
    this.setState({
      collapseOpen: !this.state.collapseOpen
    });
  };
  // closes the collapse
  closeCollapse = () => {
    this.setState({
      collapseOpen: false
    });
  };
  // creates the links that appear in the left menu / Sidebar
  createLinks = routes => {
    return routes.map((prop, key) => {
      if(prop.path == "/" || prop.path == "/addnewquotation"|| prop.path == "/addnewrot" || prop.path=="/forgetpassword" || prop.path=="/login" || prop.path =="/register"|| prop.path =="/user-profile"){
        return(null);
      }else{
        return (
          <NavItem key={key}>
            <NavLink
              to={prop.layout + prop.path}
              tag={NavLinkRRD}
              onClick={this.closeCollapse}
              activeClassName="active"
            >
              <i className={prop.icon} />
              {prop.name}
            </NavLink>
          </NavItem>
        );
      }
      
    });
  };

  
  render() {
    const imgurl = this.state.imageurllink + this.state.profileimageurl
    Moment.locale('en');
    var dt = this.state.date;
    const { bgColor, routes, logo } = this.props;
    let navbarBrandProps;
    if (logo && logo.innerLink) {
      navbarBrandProps = {
        to: logo.innerLink,
        tag: Link
      };
    } else if (logo && logo.outterLink) {
      navbarBrandProps = {
        href: logo.outterLink,
        target: "_blank"
      };
    }
    return (
      <Navbar
        className="navbar-vertical fixed-left navbar-light bg-white"
        expand="md"
        id="sidenav-main"
      >
        <Container fluid>
          {/* Toggler */}
          <button
            className="navbar-toggler"
            type="button"
            onClick={this.toggleCollapse}
          >
            <span className="navbar-toggler-icon" />
          </button>
          {/* Brand */}
          {logo ? (
            <NavbarBrand  className="pt-1" {...navbarBrandProps}>
              <Link to="/admin/dashboard">
              <img
                alt={logo.imgAlt}
                className="navbar-brand-img"                
                src={require('./../../assets/img/brand/logomewah4.png')}
              />
              </Link>
             
            </NavbarBrand>
          ) : null}
          {/* User */}
          <Nav className="align-items-center d-sm-none">
            {/* <UncontrolledDropdown nav>
              <DropdownToggle nav className="nav-link-icon">
                <i className="ni ni-bell-55" />
              </DropdownToggle>
              <DropdownMenu
                aria-labelledby="navbar-default_dropdown_1"
                className="dropdown-menu-arrow"
                right
              >
                <DropdownItem>Action</DropdownItem>
                <DropdownItem>Another action</DropdownItem>
                <DropdownItem divider />
                <DropdownItem>Something else here</DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown> */}
            <UncontrolledDropdown nav>
              <DropdownToggle nav>
                <Media className="align-items-center">
                  <span className="avatar avatar-sm rounded-circle">
                    <img
                      alt="..."
                      src={imgurl}
                    />
                  </span>
                </Media>
              </DropdownToggle>
              <DropdownMenu className="dropdown-menu-arrow" right>
                <DropdownItem className="noti-title" header tag="div">
                  <h6 className="text-overflow m-0">Welcome!</h6>
                </DropdownItem>
                    <DropdownItem to="/admin/user-profile" tag={Link}>
                    <i className="ni ni-single-02" />
                    <span>My profile</span>
                  </DropdownItem>
                  {this.state.have2account == 1 ?
                   <DropdownItem to="/admin/user-profile" onClick={(e)=>this.secondbilltopartyclick(e)}>
                   <i className="ni ni-circle-08" />
                  <span>Switch To {this.state.billtopartyaccount2}</span>
                 </DropdownItem>
                  :
                  null
                  }
                <DropdownItem divider />
                <DropdownItem href="#pablo" to="/auth/login" tag={Link} >
                    <i className="ni ni-user-run" />
                    <span>Logout</span>
                  </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
          </Nav>
          {/* Collapse */}
          <Collapse navbar isOpen={this.state.collapseOpen}>
            {/* Collapse header */}
            <div className="navbar-collapse-header d-sm-none">
              <Row>
                {logo ? (
                  <Col className="collapse-brand" xs="6">
                    {logo.innerLink ? (
                      <Link to={logo.innerLink} >
                        <img onClick={this.toggleCollapse} alt={logo.imgAlt} src={logo.imgSrc} />
                      </Link>
                    ) : (
                      <a href={logo.outterLink}>
                        <img onClick={this.toggleCollapse} alt={logo.imgAlt} src={logo.imgSrc} />
                      </a>
                    )}
                  </Col>
                ) : null}
                <Col className="collapse-close" xs="3">
                  <button
                    className="navbar-toggler "
                    type="button"
                    onClick={this.toggleCollapse}
                  >
                    <span />
                    <span />
                  </button>
                </Col>
              </Row>
            </div>
            {/* Form */}
            {/* <Form className="mt-4 mb-3 d-md-none">
              <InputGroup className="input-group-rounded input-group-merge">
                <Input
                  aria-label="Search"
                  className="form-control-rounded form-control-prepended"
                  placeholder="Search"
                  type="search"
                />
                <InputGroupAddon addonType="prepend">
                  <InputGroupText>
                    <span className="fa fa-search" />
                  </InputGroupText>
                </InputGroupAddon>
              </InputGroup>
            </Form> */}
            {/* Navigation */}
            <Nav navbar>{this.createLinks(routes)}</Nav>
            {/* Divider */}
            <hr className="my-3" />
           {/*Show Date Time */}
         
           <h6 className="navbar-heading text-muted aligntobottomtime" style={{bottom:10,minWidth:100}}>
           
             {Moment(dt).format('HH:mm:ss')} <br/> {Moment(dt).format('dddd')}  <br/> {Moment(dt).format('DD MMM YYYY')}<br/> <br/>  Version 2.0.{this.state.versionvalue}
             </h6>
         
        
          </Collapse>
        </Container>
      </Navbar>
    );
  }
}

Sidebar.defaultProps = {
  routes: [{}]
};

Sidebar.propTypes = {
  // links that will be displayed inside the component
  routes: PropTypes.arrayOf(PropTypes.object),
  logo: PropTypes.shape({
    // innerLink is for links that will direct the user within the app
    // it will be rendered as <Link to="...">...</Link> tag
    innerLink: PropTypes.string,
    // outterLink is for links that will direct the user outside the app
    // it will be rendered as simple <a href="...">...</a> tag
    outterLink: PropTypes.string,
    // the image src of the logo
    imgSrc: PropTypes.string.isRequired,
    // the alt for the img
    imgAlt: PropTypes.string.isRequired
  })
};

export default Sidebar;
